<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-comment-dots"></i> {{title | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
    <table class="table-sm table-bordered">
      <thead class="custom-font-size-table-header">
      <tr>
        <th scope="col" class="custom-col-0">#</th>
        <th scope="col" class="custom-col-1">{{ "TABLE.HEADER.TYPE" | translate }}</th>
        <th scope="col" class="custom-col-2">{{ "TABLE.HEADER.REALIZED-BY" | translate }}</th>
        <th scope="col" class="custom-col-3">{{ "TABLE.HEADER.DATE" | translate }}</th>
        <th scope="col" class="custom-col-4">{{ "TABLE.HEADER.DESCRIPTION" | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let comment of comments; let index = index" class="custom-font-size-table-body">
        <td scope="row" class="custom-col-0 font-weight-bold">{{index + 1}}</td>
        <td class="custom-col-1">
          <span class="badge {{getBadgeTextBy(comment)}}">
            {{getCommentTypeTextBy(comment) | translate}}
           </span>
        </td>
        <td class="custom-col-2">{{comment.actioner}}</td>
        <td class="custom-col-3">{{comment.createAt | dateformat}}</td>
        <td class="custom-col-4">{{comment.description}}</td>
      </tr>
      </tbody>
    </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success"
            (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}</button>
  </div>
</div>

